import request from '@/http'
// import axios from 'axios'
import api from './api'

const apiUser = {
  getUserInfo: async () => request.get(`${api}/api/user/getCurrentUserInfoV2`)
  // getUserInfo: async function () {
  //   return new Promise(async (resolve, reject) => {
  //     axios({
  //       method: 'get',
  //       url: api + '/api/user/getCurrentUserInfo'
  //     })
  //       .then(res => {
  //         resolve(res)
  //       })
  //       .catch(err => {
  //         reject(err)
  //       })
  //   })
  // }
}
export default apiUser
